import { render, staticRenderFns } from "./MenuTreballadors.vue?vue&type=template&id=0adc8052&scoped=true"
import script from "./MenuTreballadors.vue?vue&type=script&lang=js"
export * from "./MenuTreballadors.vue?vue&type=script&lang=js"
import style0 from "./MenuTreballadors.vue?vue&type=style&index=0&id=0adc8052&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0adc8052",
  null
  
)

export default component.exports